import ajax from '@/lib/ajax';
import store from '@/store';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import { AppModule } from '@/store/Auth/AppModule';
import SegregatedBalances from '@/models/Dashboard/Projections/SegregatedBalances';
import CashbackTotals from '@/models/Dashboard/Projections/CashbackTotals';

export interface DashboardState {
    loadingBalances: boolean;
    loadingCashback: boolean;
    balances: SegregatedBalances;
    cashback: CashbackTotals;
}

@Module({ dynamic: true, store, name: 'DashboardModule', namespaced: true })
class DashboardStore extends VuexModule implements DashboardState {

    public loadingBalances: boolean = true;
    public loadingCashback: boolean = true;
    public balances: SegregatedBalances = new SegregatedBalances();
    public cashback: CashbackTotals = new CashbackTotals();

    @Action
    async getSegregatedBalances() {

        this.setLoadingBalances(true);

        await ajax.get(`/portal-backend/fi-api/projections/segregated-balances`)
        .then(response => {
            this.context.commit("setBalances", response.data);
            this.setLoadingBalances(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingBalances(false);
        });
    }

    @Action
    async getCashbackTotals() {

        this.setLoadingCashback(true);

        await ajax.get(`/portal-backend/fi-api/projections/cashback-totals`)
        .then(response => {
            this.context.commit("setCashback", response.data);
            this.setLoadingCashback(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingCashback(false);
        });
    }

    @Action
    cleanState() {
        this.context.commit("resetState");
    }

    @Mutation
    resetState() {
        this.loadingBalances = true;
        this.loadingCashback = true;
    }

    @Mutation
    private async setLoadingBalances(loading: boolean) {
        this.loadingBalances = loading;
    }

    @Mutation
    private async setLoadingCashback(loading: boolean) {
        this.loadingCashback = loading;
    }

    @Mutation
    private async setBalances(balances: SegregatedBalances) {
        this.balances = balances;
    }

    @Mutation
    private async setCashback(cashback: CashbackTotals) {
        this.cashback = cashback;
    }

}

export const DashboardModule = getModule(DashboardStore);